<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="5" class="d-flex flex-column justify-center grey--text">
        <div v-for="(item, index) in features" :key="index" class="my-3 d-flex">
          <v-img
            class="mr-3"
            max-width="48"
            max-height="48"
            :src="require(`@/assets/icons/${item.icon}`)"
            :lazy-src="require(`@/assets/icons/${item.icon}`)"
          ></v-img>
          <div>
            <h2 class="title font-weight-black">{{ item.title }}</h2>
            <p class="subheading">{{ item.content }}</p>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="7" class="d-flex align-center justify-center">
        <v-img
          :src="require(`@/assets/media/InAction.gif`)"
          :lazy-src="require(`@/assets/media/InAction.gif`)"
          aspect-ratio="1"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    features: [
      {
        title: 'High resolution.',
        content: 'Retina ready photos for high-resolution screen devices.',
        icon: 'high-resolution-grey.svg',
      },
      {
        title: 'Simple setup.',
        content: `Download and use keyboard shortcut. It's simple as waving a hand!`,
        icon: 'simple-grey.svg',
      },
      {
        title: 'Carefully crafted.',
        content: 'Each photo is selected to create a unique photo collection.',
        icon: 'crafted-grey.svg',
      },
    ],
  }),
}
</script>
